import _ from 'lodash';

/**
 * Display names for the workspace user roles. The API still returns the
 * legacy "Experience *" names, these are the labels shown to the user.
 */
export const USER_ROLE_DISPLAY_NAMES = {
  'experience manager': 'Administrator (Co-Owner)',
  'experience designer': 'Content Designer',
  'experience publisher': 'Content Publisher'
};

const USER_ROLE_PRIORITY = [
  'experience manager',
  'experience publisher',
  'experience designer'
];

function getUserRoleName(role) {
  return _.isString(role) ? role : _.get(role, 'name', '');
}

function getUserRolePriority(role) {
  var index = USER_ROLE_PRIORITY.indexOf(
    getUserRoleName(role).trim().toLowerCase()
  );

  return index === -1 ? USER_ROLE_PRIORITY.length : index;
}

/**
 * A user needs at least one of the experience roles to have a seat on the
 * workspace, any other role is not enough to get into the application.
 */
export function hasExperienceRole(roles) {
  if (!_.isArray(roles)) {
    return false;
  }

  return _.some(roles, function (role) {
    return getUserRolePriority(role) < USER_ROLE_PRIORITY.length;
  });
}

export function getPrimaryUserRole(roles) {
  if (!_.isArray(roles) || roles.length === 0) {
    return null;
  }

  return _.minBy(roles, getUserRolePriority);
}

export function getUserRoleDisplayName(role) {
  var name = getUserRoleName(role);

  if (!name) {
    return name;
  }

  return USER_ROLE_DISPLAY_NAMES[name.trim().toLowerCase()] || name;
}
